<template>

    <div>

        <!-- Page Header -->
        <div class="row page-titles">
            <div class="col-md-6 col-8 align-self-center">
                <h3 class="page-title">{{inspection1.asset_name}} Inspection Comparison</h3>
            </div>
            <div class="col-md-6 col-4 align-self-center">
                <div class="dropdown pull-right mr-4">
                    <button class="btn btn-primary mt-1" :disabled="reportForm.busy"
                            @click.prevent="showComparisonReportOptions('pdf', null)">
                        {{reportForm.busy && reportForm.type === "pdf" ? "Building report..." : "Pdf Report"}}
                    </button>
                    <button class="btn btn-primary mt-1" :disabled="reportForm.busy"
                            @click.prevent="showComparisonReportOptions('excel', null)">{{reportForm.busy &&
                        reportForm.type ===
                        "excel" ? "Building report..." : "Excel Report"}}
                    </button>
                    <button class="btn btn-default mt-1" @click="showDocumentsPanel = true">View Reports</button>
                </div>
            </div>
        </div>

        <!-- Inspections Details -->
        <div class="row bg-white ml-0 mr-0" style="border-radius: 4px;">

            <div class="col-sm-5">
                <div class="bg-inspection-1 p-4">
                    <h5 class="inspection-info">
                        <a :href="'/inspections/' + inspection1.id">{{inspection1.type}} Inspection</a>
                    </h5>
                    <h5 class="inspection-info">
                        {{inspection1.date | localeUnawareDatetime}}
                    </h5>
                    <h5>
                        Inspector <span class="inspection-info">{{inspection1.inspector_name}}</span>
                    </h5>
                    <h5 v-if="inspection1.tenant_name">
                        Tenant <span class="inspection-info">{{inspection1.tenant_name}}</span>
                    </h5>
                </div>
            </div>

            <div class="col-sm-2">

            </div>

            <div class="col-sm-5">

                <div class="bg-inspection-1 p-4">
                    <el-select class="w-100 mb-2"
                               v-if="isChangingInspection"
                               placeholder="Select inspection to compare"
                               v-model="inspection2"
                               value-key="id"
                               @change="compareWith">
                        <el-option
                                class="inspection-dropdown-item"
                                v-for="inspection in comparableInspections"
                                :key="inspection.id"
                                :label="inspection.type + ' Inspection on ' + $options.filters.localeUnawareDatetime(inspection.date)"
                                :value="inspection">
                            <div>
                                <div style="max-width: 400px">
                                    <div>
                                        {{inspection.tenant_name}}
                                    </div>
                                    <div>
                            <span>{{ inspection.type }}
                                <i class="mdi mdi-calendar icon-light"></i>
                                {{ inspection.date | localeUnawareDatetime }}
                                <span class="label label-light-info pull-right">{{ inspection.status }}</span>
                            </span>
                                    </div>
                                    <div>
                                        <p class="mb-0 mt-1 font-sm">{{ inspection.comments }}</p>
                                    </div>
                                </div>
                            </div>
                        </el-option>
                    </el-select>
                    <div v-if="!isChangingInspection">
                        <h5 class="inspection-info">
                            <a :href="'/inspections/' + inspection2.id">{{inspection2.type}} Inspection</a>
                        </h5>
                        <h5 class="inspection-info">
                            {{inspection2.date | localeUnawareDatetime}}
                        </h5>
                        <h5>
                            Inspector <span class="inspection-info">{{inspection2.inspector_name}}</span>
                        </h5>
                        <h5 v-if="inspection2.tenant_name">
                            Tenant <span class="inspection-info">{{inspection2.tenant_name}}</span>
                        </h5>

                    </div>
                    <a class="change-comparison-link" @click.prevent="isChangingInspection = !isChangingInspection"
                       href="#">{{isChangingInspection ? "Cancel" : "Change"}}</a>
                </div>

            </div>

        </div>

        <!-- Comparison Filters -->
        <div class="comparison-filters-container form-inline mt-4 mb-2">
            <div class="btn-group mr-2">
                <button type="button" class="btn btn-outline-default dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ areaFilter | capitalize }}
                </button>
                <div class="dropdown-menu">
                    <a class="dropdown-item" href="#" v-for="area in comparisonAreas"
                       @click.prevent="filterAreas(area.name)">
                        {{ area.name }}
                    </a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#" @click.prevent="filterAreas('all')">All</a>
                </div>
            </div>
            <div class="input-group mr-2">
                <input type="text"
                       v-model="checklistSearchFilter"
                       placeholder="Search checklist"
                       @keyup.enter="submitSearch"
                       class="form-control">
                <div class="input-group-append">
                    <button class="btn btn-default" type="button" @click="submitSearch">
                        Search
                    </button>
                </div>
            </div>
            <a href="#" class="recommendations-filter-toggle waves-effect waves-light mr-2"
               @click.prevent="toggleRecommendationsOnlyFilter">
                <img :src="recommendationFilterIcon"/>
            </a>
            <div class="input-group mr-2">
                <label class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" v-model="compareComments"
                           @change="fetchComparison()">
                    <span class="custom-control-label">Compare comments</span>
                </label>
            </div>
            <div class="input-group mr-2">
                <label class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" v-model="deviationsOnlyFilter"
                           @change="fetchComparison()">
                    <span class="custom-control-label">Only Show Deviations</span>
                </label>
            </div>
        </div>

        <!-- Comparison Record -->
        <div class="row">

            <div class="col-sm-12 mt-2" v-for="comparisonArea in comparisonChecklist">
                <h4 class="p-2 mb-0">{{comparisonArea.area_name}}</h4>

                <table class="table p-0">
                    <thead style="visibility: collapse;">
                    <th style="width:40%"></th>
                    <th style="width:100px"></th>
                    <th style="width:40%"></th>
                    </thead>
                    <tbody>
                    <tr class="comparison-line cursor-pointer" v-for="comparisonItem in comparisonArea.items"
                        @click.prevent="viewComparisonDetail(comparisonItem)">

                        <td :class="backgroundColorForItemRow(comparisonItem)">
                            <div class="pull-right" v-if="comparisonItem[0]">
                                <div class="pull-right">
                                        <span class="item-condition-label"
                                              v-if="comparisonItem[0].cleanliness">{{comparisonItem[0].cleanliness}}</span>
                                    <span class="item-condition-label" v-if="comparisonItem[0].damage">{{comparisonItem[0].damage}}</span>
                                    <span class="item-condition-label"
                                          v-if="comparisonItem[0].functioning">{{comparisonItem[0].functioning}}</span>
                                </div>
                                <div class="flow-root"></div>
                                <div class="pull-right">
                                    <p class="mt-1 mb-0 item-comments text-right">{{comparisonItem[0].comments}}
                                        <span class="item-recommendation">
                                            {{comparisonItem[0].recommendation}}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </td>

                        <td style="overflow: hidden">
                            <div class="comparison-line text-center">
                                <span class="comparison-item-name" :class="comparisonItemClasses(comparisonItem)"
                                      v-if="comparisonItem[0]">{{comparisonItem[0].item}}</span>
                                <span class="comparison-item-name" :class="comparisonItemClasses(comparisonItem)"
                                      v-else-if="comparisonItem[1]">{{comparisonItem[1].item}}</span>
                            </div>
                        </td>

                        <td :class="backgroundColorForItemRow(comparisonItem)">
                            <div v-if="comparisonItem[1]">
                                <div>
                                    <span class="item-condition-label" v-if="comparisonItem[1].cleanliness">{{comparisonItem[1].cleanliness}}</span>
                                    <span class="item-condition-label" v-if="comparisonItem[1].damage">{{comparisonItem[1].damage}}</span>
                                    <span class="item-condition-label" v-if="comparisonItem[1].functioning">{{comparisonItem[1].functioning}}</span>
                                </div>
                                <p class="mt-1 mb-0 item-comments">
                                    <span class="item-recommendation">
                                        {{comparisonItem[1].recommendation}}
                                    </span>
                                    {{comparisonItem[1].comments}}
                                </p>
                            </div>
                        </td>

                    </tr>
                    </tbody>
                </table>

            </div>

        </div>

        <!-- Comparison Detail Panel -->
        <comparison-item-detail :comparison-item="selectedComparisonRecord"
                                :show="this.selectedComparisonRecord !== null"
                                v-on:close-item-detail-panel="clearSelectedItem">

        </comparison-item-detail>

        <!-- Inspection Reports Panel -->
        <transition name="slide-right-panel">
            <div class="side-panel right-sidebar shw-rside" style="z-index: 1041;" v-if="showDocumentsPanel">
                <div class="rpanel-title font-medium">
                    Inspection Documents <span @click="showDocumentsPanel = false;"><i
                        class="icon mdi mdi-close right-side-toggle"></i></span>
                </div>
                <div class="custom-scroll" style="display: block; height: 100vh; overflow: scroll; padding: 15px;">
                    <document-list :document-list-url="documentListUrl"
                                   :allow-upload=false
                                   :allow-share=false>

                    </document-list>
                </div>
            </div>
        </transition>

        <!-- Reporting Modal -->
        <div id="modal-report-settings-form" class="modal fade" tabindex="-1" role="dialog"
             style="display: none;">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title font-normal" id="modalTitle">Comparison {{reportForm.type}} Report</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <form class="form">

                            <div class="form-group p-3" v-if="reportForm.type === 'pdf'">
                                <label class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input"
                                           v-model="reportForm.hideEmptyItems">
                                    <span class="custom-control-label">Hide Empty Items
                                        <small class="text-muted"><br/>Exclude items without any information (description, comment, action, photos) from the pdf report.</small>
                                    </span>
                                </label>
                            </div>

                            <div class="form-group p-3" v-if="reportForm.type === 'pdf'">
                                <label class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input"
                                           v-model="reportForm.hidePhotos">
                                    <span class="custom-control-label">Hide Photos
                                <small class="text-muted"><br/>Don't add any photos to the report.</small>
                            </span>
                                </label>
                            </div>

                            <div class="form-group p-3">
                                <label class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input"
                                           v-model="reportForm.recommendationsOnly">
                                    <span class="custom-control-label">Recommendations Only
                                        <small class="text-muted"><br/>Only add items with recommendations to the report.</small>
                                    </span>
                                </label>
                            </div>

                            <div class="form-group p-3">
                                <label class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input"
                                           v-model="reportForm.deviationsOnly">
                                    <span class="custom-control-label">Deviations Only
                                        <small class="text-muted"><br/>Only add deviating items to the report.</small>
                                    </span>
                                </label>
                            </div>

                            <div class="form-group p-3">
                                <label class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input"
                                           v-model="reportForm.compareComments">
                                    <span class="custom-control-label">Compare Comments
                                        <small class="text-muted"><br/>Also compare item comments when checking for deviations.</small>
                                    </span>
                                </label>
                            </div>

                        </form>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success waves-effect waves-light"
                                @click.prevent="generateComparisonReport()"
                                :disabled="reportForm.busy">
                            Generate
                        </button>
                        <button type="button" class="btn btn-default waves-effect" data-dismiss="modal"
                                :disabled="reportForm.busy">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    export default {

        props: ["inspection", "otherInspection", "comparableInspections"],

        data () {
            return {
                inspection1: this.inspection,
                inspection2: this.otherInspection,
                comparisonChecklist: [],
                isChangingInspection: false,
                areaFilter: "all",
                checklistSearchFilter: "",
                recommendationsOnlyFilter: false,
                deviationsOnlyFilter: false,
                compareComments: false,
                reportForm: new AppForm({}),
                selectedComparisonRecord: null,
                showDocumentsPanel: false
            };
        },

        computed: {

            comparisonAreas () {
                return _.uniqBy(this.inspection1.checklist_areas.concat(this.inspection2.checklist_areas), "name");
            },

            recommendationFilterIcon () {
                return this.recommendationsOnlyFilter ? "/images/recommendation-full.svg" : "/images/recommendation-empty.svg";
            },

            documentListUrl () {
                return "/inspections/" + this.inspection1.id + "/documents";
            }

        },

        mounted () {
            this.fetchComparison();
        },

        methods: {
            compareWith () {
                this.isChangingInspection = false;
                this.fetchComparison();
            },

            fetchComparison () {
                axios.get("/inspections/" + this.inspection1.id + "/compare", {
                    params: {
                        otherInspection: this.inspection2.id,
                        areaFilter: this.areaFilter,
                        filterItems: this.checklistSearchFilter,
                        recommendationsOnly: this.recommendationsOnlyFilter,
                        deviationsOnly: this.deviationsOnlyFilter,
                        compareComments: this.compareComments
                    }
                }).then(response => {
                    this.comparisonChecklist = response.data;
                });
            },

            backgroundColorForItemRow (item) {
                if (item["diff_condition"] === true) {
                    return "bg-diff-condition";
                }

                if (item["diff_comments"] === true) {
                    return "bg-diff-comments";
                }

                return "bg-diff-none";
            },

            comparisonItemClasses (item) {
                let diffClasses = "label label-light-info comparison-item-diff";

                if (item["diff_condition"] === true) {
                    return diffClasses;
                }

                if (item["diff_comments"] === true) {
                    return diffClasses;
                }

                return "comparison-item-diff-none";
            },

            submitSearch () {
                this.fetchComparison();
            },

            filterAreas (area) {
                this.areaFilter = area;
                this.fetchComparison();
            },

            toggleRecommendationsOnlyFilter () {
                this.recommendationsOnlyFilter = !this.recommendationsOnlyFilter;
                this.fetchComparison();
            },

            showComparisonReportOptions (type) {
                this.reportForm = new AppForm({
                    otherInspection: this.inspection2.id,
                    type: type,
                    areaFilter: this.areaFilter,
                    filterItems: this.checklistSearchFilter,
                    recommendationsOnly: this.recommendationsOnlyFilter,
                    deviationsOnly: this.deviationsOnlyFilter,
                    compareComments: this.compareComments
                });

                $("#modal-report-settings-form").modal("show");
            },

            generateComparisonReport () {
                $("#modal-report-settings-form").modal("hide");

                App.post("/inspections/" + this.inspection1.id + "/compare/reports/" + this.reportForm.type, this.reportForm)
                .then(response => {
                    toastr.success("Report Saved!");
                    //this.activateTab("documents");
                    if (response.url) {
                        window.open(response.url, "_blank");
                    }
                    //Bus.$emit("document-added", response);
                })
                .catch(errors => {
                    toastr.error("Error generating report: " + errors.message);
                });
            },

            viewComparisonDetail (comparisonItem) {
                this.showDocumentsPanel = false;
                this.selectedComparisonRecord = comparisonItem;
            },

            clearSelectedItem () {
                this.selectedComparisonRecord = null;
            },
        },
    };
</script>

<style>
    .inspection-dropdown-item {
        white-space: normal !important;
        overflow: auto !important;
        height: auto !important;
        line-height: 22px !important;
        padding: 8px 20px !important;
    }

    .bg-inspection-1 {
        background: #fff;
        border-radius: 4px;
        height: 100%;
    }

    .bg-inspection-1 h5 {
        font-weight: 400;
    }

    .bg-inspection-1 a {
    }

    .bg-diff-condition {
        background: #dee2e6;
    }

    .bg-diff-comments {
        background: #dee2e6;
    }

    .bg-diff-none {
        background: #fff;
    }

    .comparison-filters-container {
        background: #fff;
        border-radius: 4px;
        padding: 16px;
    }

    .inspection-info {
        font-weight: 400;
    }

    .change-comparison-link {
        text-decoration: underline;
        line-height: 1.5;
        color: #6faaf3;
        font-weight: 500;
    }

    .comparison-line {
        vertical-align: center;
    }

    .item-condition-label {
        padding: 3px 5px;
        font-size: 12px;
        min-width: 56px;
        background: #6faaf3;
        font-weight: 400;
        border-radius: 0.25rem;
        color: #fff;
    }

    .comparison-item-name {
    }

    .item-comments {
        font-size: 12px;
    }

    .item-recommendation {
        font-size: 12px;
        font-weight: 500;
        color: #b11623;
    }

    .comparison-item-diff {
        overflow: hidden;
        text-align: center;
    }

    .comparison-item-diff:before,
    .comparison-item-diff:after {
        background: #dee2e6;
        content: "";
        display: inline-block;
        height: 2px;
        position: relative;
        vertical-align: middle;
        width: 50%;
    }

    .comparison-item-diff:before {
        right: 1em;
        margin-left: -50%;
    }

    .comparison-item-diff:after {
        left: 1em;
        margin-right: -50%;
    }

    .comparison-item-diff-none {
        font-weight: 400;
    }

    .inspection-comparison-icon {
        font-size: 100px;
        color: #b11623;
    }

</style>
